<template>
  <transition name="fade">
    <div class="modal" :class="{ 'modal--open': show }" v-show="show">
      <div class="modal__wrapper" @click="$emit('close')">
        <div class="container">
          <div class="modal__icon"><slot name="icon"></slot></div>
          <div class="modal__header"><slot name="header"></slot></div>
          <div class="modal__body"><slot name="body"></slot></div>
          <div class="modal__footer"><slot name="footer"> </slot></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['show', 'close'],
};
</script>

<style lang="scss" scoped>
$black: #000;
$white: #fff;

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($black, 0.5);
  z-index: 9999;

  &--open {
    overflow: hidden;
  }

  &__wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 50px);
    height: auto;
    background: $white;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba($black, 0.5);
    padding: 20px 0;
  }

  &__icon {
    margin: 10px auto;
    width: 60px;
    height: 60px;
  }

  &__header,
  &__body {
    padding: 0 20px;
    text-align: center;
  }

  &__header {
    margin: 0 0 10px;
  }

  &__body {
    margin: 0 0 65px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
